import {
  HTTP_UPDATEINITIALAPPROVE_FETCHING,
  HTTP_UPDATEINITIALAPPROVE_SUCCESS,
  HTTP_UPDATEINITIALAPPROVE_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateUpdateInitialApproveToFetching = () => ({
  type: HTTP_UPDATEINITIALAPPROVE_FETCHING,
});

export const setStateUpdateInitialApproveToSuccess = (payload) => ({
  type: HTTP_UPDATEINITIALAPPROVE_SUCCESS,
  payload,
});

export const setStateUpdateInitialApproveToFailed = (payload) => ({
  type: HTTP_UPDATEINITIALAPPROVE_FAILED,
});

export const updateInitialApprove = (item) => {
  return async (dispatch) => {
    dispatch(setStateUpdateInitialApproveToFetching());

    try {
      const result = await httpClient.post(
        `${server.UPDATEINITIALAPPROVE_URL}`,
        item
      );
      dispatch(setStateUpdateInitialApproveToSuccess("success"));
    } catch (err) {
      dispatch(setStateUpdateInitialApproveToFailed());
    }
  };
};
